/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OAuth2AuthorizeResponse } from '../models/OAuth2AuthorizeResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AzureService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Oauth:Azure.Cookie.Authorize
     * @returns OAuth2AuthorizeResponse Successful Response
     * @throws ApiError
     */
    public oauthCookieAuthorize({
        scopes,
    }: {
        scopes?: Array<string>,
    }): CancelablePromise<OAuth2AuthorizeResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/auth/cookie/azure/authorize',
            query: {
                'scopes': scopes,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Oauth:Azure.Cookie.Callback
     * The response varies based on the authentication backend used.
     * @returns any Successful Response
     * @throws ApiError
     */
    public oauthCookieCallback({
        code,
        codeVerifier,
        state,
        error,
    }: {
        code?: string,
        codeVerifier?: string,
        state?: string,
        error?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/auth/cookie/azure/callback',
            query: {
                'code': code,
                'code_verifier': codeVerifier,
                'state': state,
                'error': error,
            },
            errors: {
                400: `Bad Request`,
                422: `Validation Error`,
            },
        });
    }

    /**
     * Oauth:Azure.Bearer.Authorize
     * @returns OAuth2AuthorizeResponse Successful Response
     * @throws ApiError
     */
    public oauthBearerAuthorize({
        scopes,
    }: {
        scopes?: Array<string>,
    }): CancelablePromise<OAuth2AuthorizeResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/auth/bearer/azure/authorize',
            query: {
                'scopes': scopes,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Oauth:Azure.Bearer.Callback
     * The response varies based on the authentication backend used.
     * @returns any Successful Response
     * @throws ApiError
     */
    public oauthBearerCallback({
        code,
        codeVerifier,
        state,
        error,
    }: {
        code?: string,
        codeVerifier?: string,
        state?: string,
        error?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/auth/bearer/azure/callback',
            query: {
                'code': code,
                'code_verifier': codeVerifier,
                'state': state,
                'error': error,
            },
            errors: {
                400: `Bad Request`,
                422: `Validation Error`,
            },
        });
    }

    /**
     * Oauth:Azure.Cli Handoff.Authorize
     * @returns OAuth2AuthorizeResponse Successful Response
     * @throws ApiError
     */
    public oauthCliHandoffAuthorize({
        scopes,
    }: {
        scopes?: Array<string>,
    }): CancelablePromise<OAuth2AuthorizeResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/auth/cli/azure/authorize',
            query: {
                'scopes': scopes,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Oauth:Azure.Cli Handoff.Callback
     * The response varies based on the authentication backend used.
     * @returns any Successful Response
     * @throws ApiError
     */
    public oauthCliHandoffCallback({
        code,
        codeVerifier,
        state,
        error,
    }: {
        code?: string,
        codeVerifier?: string,
        state?: string,
        error?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/auth/cli/azure/callback',
            query: {
                'code': code,
                'code_verifier': codeVerifier,
                'state': state,
                'error': error,
            },
            errors: {
                400: `Bad Request`,
                422: `Validation Error`,
            },
        });
    }

}
